<template>
  <div>
    <p class="modal">This statement is made pursuant to s.54 of the Modern Slavery Act 2015 and sets out the steps that Rare Recruitment has taken and is continuing to take to ensure that modern slavery or human trafficking is not taking place within our business or supply chain.</p>
    <p class="modal">Modern slavery encompasses slavery, servitude, human trafficking and forced labour. Rare Recruitment Ltd has a zero tolerance approach to any form of modern slavery. We are committed to acting ethically and with integrity and transparency in all business dealings and to putting effective systems and controls in place to safeguard against any form of modern slavery taking place within the business or our supply chain.</p>
    <h3 class="modal">Our business</h3>
    <p class="modal">Rare Recruitment Limited is a company operating in the UK. Rare has an annual turnover of £1.7 million and employs 35 members of staff working in London and remotely. Rare is a graduate recruitment specialist that works in two main areas: (i) helping students from underrepresented backgrounds gain access to top jobs and (ii) providing contextual data to help a series of private and public sector clients put candidate achievements into context. </p>
    <h3 class="modal">Our policies</h3>
    <p class="modal"> We operate a number of internal policies to ensure that we are conducting business in an ethical and transparent manner. These include:</p>
    <ol class="modal">
      <li>Anti-slavery policy.  This policy sets out the organisation’s stance on modern slavery and explains how employees can identify any instances of this and where they can go for help. <br>
      </li>
      <li>Recruitment policy. We operate a robust recruitment policy, including conducting eligibility to work in the UK checks for all employees to safeguard against human trafficking or individuals being forced to work against their will. <br>
      </li>
      <li>Whistleblowing policy. We operate a whistleblowing policy so that all employees know that they can raise concerns about how colleagues are being treated, or practices within our business or supply chain, without fear of reprisals.<br>
      </li>
      <li>Code of business conduct.  This code explains the manner in which we behave as an organisation and how we expect our employees and suppliers to act.</li>
    </ol>

    <h3 class="modal">Our suppliers</h3>
    <p class="modal">Rare Recruitment operates a supplier policy and maintains a preferred supplier list.  We conduct due diligence on all suppliers before allowing them to become a preferred supplier.  This due diligence includes an online search to ensure that particular organisation has never been convicted of offences relating to modern slavery. Our anti-slavery policy forms part of our contract with all suppliers and they are required to confirm that no part of their business operations contradicts this policy. </p>
    <p class="modal">In addition to the above, as part of our contract with suppliers, we require that they confirm to us that: </p>
    <ol class="modal">
      <li>They have taken steps to eradicate modern slavery within their business<br>
      </li>
      <li>They hold their own suppliers to account over modern slavery<br>
      </li>
      <li>(For UK based suppliers) They pay their employees at least the national minimum wage / national living wage (as appropriate)<br>
      </li>
      <li>(For international suppliers) They pay their employees any prevailing minimum wage applicable within their country of operations<br>
      </li>
      <li>We may terminate the contract at any time should any instances of modern slavery come to light.</li>
    </ol>

    <h3 class="modal">Our performance indicators</h3>
    <p class="modal">We will know the effectiveness of the steps that we are taking to ensure that slavery and/or human trafficking is not taking place within our business or supply chain if:</p>
    <ul class="modal">
      <li>No reports are received from employees, the public, or law enforcement agencies to indicate that modern slavery practices have been identified.</li>
    </ul>

    <h3 class="modal">Approval for this statement</h3>
    <p class="modal">This statement was approved by the Board of Directors on 23rd November 2022.</p>
    <p class="modal">Signatory: Anna Burgess, Director, Finance and Administration</p>
    <p class="modal">Date: 23rd November 2022</p>
  </div>
</template>

<script>
export default {
  name: 'RareLegalModernSlavery',
  mounted() {
    this.$emit('hideNavigation');
  },
  destroyed() {
    this.$emit('showNavigation');
  },
};

</script>

<style lang="scss" scoped>
  .signature {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/legal/components/RareLegalModernSlaveryStatement.vue